export const formatPrice = (price) => {
  // Handle undefined, null, or NaN
  if (price === undefined || price === null || isNaN(price)) {
    return "0";
  }
  
  // Round to nearest integer
  const roundedPrice = Math.round(price);
  
  // Convert to string with thousand separators (spaces)
  return roundedPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}; 